import React from "react";
import { Table, Button} from "react-bootstrap";
import { PDFDocument, rgb, StandardFonts } from "pdf-lib";
import { saveAs } from "file-saver";
import ToPeso from "../components/misc/ToPeso";
import { format } from "date-fns";

function DocumentDemandLetter({ applicantDetails, loanProcessingDetails }) {

  if (!applicantDetails) {
    return null;
  }

  const handleSubmit = async (selectedLoan) => {

    if (!selectedLoan) return;


    const existingPdfBytes = await fetch("/pdftemplates/demand-letter.pdf").then(res =>
      res.arrayBuffer()
    );

    const pdfDoc = await PDFDocument.load(existingPdfBytes);
    const helveticaFont = await pdfDoc.embedFont(StandardFonts.Helvetica);
    const helveticaFontBold = await pdfDoc.embedFont(StandardFonts.HelveticaBold);

    const pages = pdfDoc.getPages();
    const firstPage = pages[0];

    // borrower name
    firstPage.drawText(`${applicantDetails.firstName.toUpperCase()} ${applicantDetails.middleName.toUpperCase() || ""} ${applicantDetails.lastName.toUpperCase()}`, {
      x: 37,
      y: 640,
      size: 9,
      font: helveticaFontBold, 
      color: rgb(0, 0, 0)
    });

    firstPage.drawText(`${applicantDetails.street.toUpperCase()}, ${applicantDetails.barangay.toUpperCase()},`, {
        x: 37,
        y: 628,
        size: 7,
        font: helveticaFont,
        color: rgb(0, 0, 0),
    });

    firstPage.drawText(`${applicantDetails.municipality.toUpperCase()}, ${applicantDetails.province.toUpperCase()} ${applicantDetails.zipCode.toUpperCase()}`, {
        x: 37,
        y: 619,
        size: 7,
        font: helveticaFont,
        color: rgb(0, 0, 0),
    });

    //dates

    // Get today's date
    const today = new Date();

    // Extract day, month, and year
    const day = today.getDate();
    const month = today.toLocaleString('default', { month: 'long' }); // e.g., "January", "February"
    const year = today.getFullYear();
    const dayName = today.toLocaleDateString('en-US', { weekday: 'long' });

    firstPage.drawText(`${dayName}, ${month} ${day}, ${year}`, {
      x: 37,
      y: 665,
      size: 9,
      font: helveticaFont, 
      color: rgb(0, 0, 0)
    });

    const pdfBytes = await pdfDoc.save();
    saveAs(new Blob([pdfBytes]), `Demand Letter_${applicantDetails.firstName}_${applicantDetails.lastName}_${selectedLoan.id}.pdf`);
  };

  return (
    <>
      <h3>Applicant Details</h3>
      <Table className="list-container" hover responsive>
        <tbody>
          <tr>
            <td><strong>Full Name</strong></td>
            <td>{`${applicantDetails.firstName} ${applicantDetails.middleName || ""} ${applicantDetails.lastName}`}</td>
          </tr>
          <tr>
            <td><strong>Address</strong></td>
            <td>{`${applicantDetails.street}, ${applicantDetails.barangay}, ${applicantDetails.municipality}, ${applicantDetails.province}`}</td>
          </tr>
        </tbody>
      </Table>

      <h3>Loan Processing Details</h3>
      {loanProcessingDetails.length > 0 ? (
        <Table className="list-container" hover responsive>
          <thead>
            <tr>
              <th>Type</th>
              <th>Amount Granted</th>
              <th>Date Granted</th>
              <th>Interest Rate</th>
              <th>Loan Term</th>
              <th>Payment Type</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {loanProcessingDetails.map((loan, index) => (
              <tr key={index}>
                <td>{loan.loanProcessingType}</td>
                <td><ToPeso amount={parseFloat(loan.amountGranted).toFixed(2)} /></td>
                <td>{format(new Date(loan.dateGranted), "MM/dd/yyyy")}</td>
                <td>{loan.interestRate}%</td>
                <td>{loan.loanTerm} months</td>
                <td>{loan.paymentType}</td>
                <td>
                  <Button variant="primary" onClick={() => handleSubmit(loan)}>
                    Generate Demand Letter
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      ) : (
        <p>No loan processing details found for this applicant.</p>
      )}
    </>
  );
}

export default DocumentDemandLetter;